document.addEventListener('click', (event) => {
  const railButton = event.target.closest('[data-fw-rail-direction]');
  if (railButton) {
    const grid = railButton.closest('[data-fw-rail]').querySelector('[data-fw-rail-grid]');
    grid.scrollBy({left: Number(railButton.dataset.fwRailDirection) * Math.max(228, grid.clientWidth * .8), behavior: 'smooth'});
  }
  const toggle = event.target.closest('[data-fw-toggle-menu]');
  if (toggle) {
    const open = toggle.closest('header').classList.toggle('fw-menu-open');
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Fermer le menu" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Chiudi il menu" : globalThis.fwExtraText("fw_extra.s_48700e16fc0c55", 'Menü schließen'))) : (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Ouvrir le menu" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Apri il menu" : globalThis.fwExtraText("fw_extra.s_ac3b2ef4fee11c", 'Menü öffnen'))));
  }
  document.querySelectorAll('.fw-nav-dropdown[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', event => {
  if(event.key === 'Escape') document.querySelectorAll('.fw-nav-dropdown[open]').forEach(menu => {menu.open = false;});
});
